import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminManageCurrencyService from "../services/admin-manageCurrency.service";
import { setCurrencyRate } from "../actions/login/login";

// Bug 1596: fetch the logged-in dealer's currency conversion rate (USD base) so that the
// price-slider filters can scale their hard-coded USD max to the dealer's currency.
// High-value currencies (JPY/INR) have prices that exceed the hard-coded 1,000,000 / 100,000
// caps; multiplying the cap by the rate keeps the slider range usable. Falls back to 1 (USD).
export default function useCurrencyRate(dealerId) {
  const dispatch = useDispatch();
  const currencyRate =
    useSelector((state) => state.loginReducer.currencyRate) || 1;

  useEffect(() => {
    if (!dealerId) return;
    AdminManageCurrencyService.GetSelectlanguageForDelar({ delarId: dealerId })
      .then((response) => {
        if (response?.data?.message === "Success") {
          const rate = response.data.responseData?.conversionRate;
          dispatch(setCurrencyRate(rate && rate > 0 ? rate : 1));
        }
      })
      .catch(() => {});
  }, [dealerId, dispatch]);

  return currencyRate;
}
